import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { Cart } from "../_models/index";
import { DataService } from "../_services/data.service";

@Component({
  selector: "questionsmodal",
  moduleId: module.id,
  templateUrl: "questionsmodal.component.html",
  styleUrls: ["questionsmodal.component.scss"],
})
export class QuestionsModal {
  @Input() event: any;
  @Input() child: any;
  @Input() fromcheckout: boolean;
  @Input() fromevent: boolean;
  @Output() checkoutAction: EventEmitter<void> = new EventEmitter<void>();
  modalReference: any;
  cart: Cart;

  constructor(
    private modalService: NgbModal,
    private dataService: DataService
  ) {
    this.cart = JSON.parse(localStorage.getItem("cart"));
    this.dataService.cart.subscribe((nextVal) => {
      this.cart = nextVal;
    });
  }

  onCheckout() {
    this.modalReference.close();
    this.checkoutAction.emit();
  }

  isAllowPurchase(event) {
    if (event.allowPurchase) {
      return true;
    } else {
      //check if tax item in the cart
      let allow = false;
      if (this.cart && this.cart.items && this.cart.items.length > 0) {
        this.cart.items.forEach((item) => {
          if (
            item &&
            item.item &&
            item.item.childId == event.childId &&
            item.item.isTax
          ) {
            allow = true;
          }
        });
      }
      return allow;
    }
  }

  getLabelText(event) {
    if (this.isAllowPurchase(event)) return "הוספה לסל";
    else return "חייב לשלם מס";
  }

  openNoTax(content) {
    let options: NgbModalOptions = {
      windowClass: "modal-opened",
      backdrop: "static",
    };
    this.modalReference = this.modalService.open(content, options);
  }

  open(content) {
    if (
      this.event &&
      this.event.questions &&
      this.event.questions.length &&
      this.event.questions.length > 0
    ) {
      let options: NgbModalOptions = {
        windowClass: "modal-opened",
        backdrop: "static",
      };
      this.modalReference = this.modalService.open(content, options);
    } else {
      //     	 this.event.child = this.child;
      this.event.childId = this.child.childId;
      this.event.firstName = this.child.firstName;
      this.event.lastName = this.child.lastName;
      this.event.isInCart = !this.event.isProduct;
      this.dataService.addToCart(this.event).subscribe((data) => {});
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cart/questionsmodal.component.ts